import { render, staticRenderFns } from "./PerfectData.vue?vue&type=template&id=5f95f704&scoped=true&"
import script from "./PerfectData.vue?vue&type=script&lang=js&"
export * from "./PerfectData.vue?vue&type=script&lang=js&"
import style0 from "./PerfectData.vue?vue&type=style&index=0&id=5f95f704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f95f704",
  null
  
)

export default component.exports